import { Component, Structure, Modes } from '@wix/thunderbolt-becky-types'
import { IPropsStore } from '@wix/thunderbolt-symbols'
import { MODES_TYPE } from '@wix/thunderbolt-commons'
import { SospActivation } from '../types'
import { MASTER_PAGE, SOSP_CONTAINER_CUSTOM_ID, SOSP_MODE_TYPE } from '../constants'

const getComponentModesAncestor = (id: string, structure: Structure) => {
	let comp: Component = structure[id]
	while (comp && !(comp.modes && comp.modes.definitions && comp.modes.definitions.length > 0)) {
		comp = structure[comp.parent!]
	}
	return comp
}

export const getActiveMode = (compId: string, structure: Structure, props: IPropsStore) => {
	const componentModesAncestor = getComponentModesAncestor(compId, structure)
	const definitions =
		componentModesAncestor.modes && componentModesAncestor.modes.definitions
			? componentModesAncestor.modes.definitions
			: []
	const mode = (componentModesAncestor.id && props.get(componentModesAncestor.id)?.mode) || 'default'
	const hoverActiveMode = definitions.find((definition) => definition.type === MODES_TYPE[mode])
	const sospActiveMode = definitions.find((definition) => definition.type === SOSP_MODE_TYPE)
	return hoverActiveMode || sospActiveMode
}

export const getCompOverridesByModeId = (compModes: Modes, activeModeId: string) => {
	const compModesOverrides = compModes.overrides ? compModes.overrides : []
	return compModesOverrides.find((override) => override.modeIds![0] === activeModeId) || {}
}

const isCompHiddenByMode = (activeModeId: string, compModes?: Modes) => {
	if (!compModes) {
		return false
	}
	const modeOverride = getCompOverridesByModeId(compModes, activeModeId)
	return modeOverride.isHiddenByModes !== undefined ? modeOverride.isHiddenByModes : compModes.isHiddenByModes
}

const isOverrideKey = (overrideKey: string) => overrideKey !== 'modeIds' && overrideKey !== 'isHiddenByModes'

export const isModesFeatureActive = (component: Component) =>
	component.modes &&
	((component.modes.overrides && component.modes.overrides.length > 0) ||
		(component.modes.definitions && component.modes.definitions.length > 0) ||
		typeof component.modes!.isHiddenByModes === 'boolean')

export const inflateHoverBoxWithModes = (component: Component, structure: Structure, activeMode: string) => {
	const compModeOverrides: { [index: string]: any } = getCompOverridesByModeId(component.modes!, activeMode)
	const compOverrides = Object.keys(compModeOverrides)
		.filter((override) => isOverrideKey(override))
		.reduce(
			(overrides, override) => ({
				...overrides,
				[override]: compModeOverrides[override],
			}),
			{}
		)
	return {
		...component,
		...compOverrides,
		components: component.components
			? component.components.filter((comp) => !isCompHiddenByMode(activeMode, structure[comp].modes))
			: component.components,
		parent: isCompHiddenByMode(activeMode, structure[component.id].modes) ? null : component.parent,
	}
}

export const inflateSospWithModes = (component: Component, isSospActiveOnCurrentPage: SospActivation) => {
	if (!isSospActiveOnCurrentPage()) {
		if (component.id === MASTER_PAGE) {
			return {
				...component,
				components: component.components!.filter((compId) => compId !== SOSP_CONTAINER_CUSTOM_ID),
			}
		}
		if (component.id === SOSP_CONTAINER_CUSTOM_ID) {
			return { ...component, parent: null }
		}
		return component
	}
	return component
}
